// Styles
import './marquee.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMarquee = (context) => {
  const marqueeSection = context.closest('.shopify-section');

  const $mq = $(context).marquee({
    duration: 25000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'left',
    startVisible: true,
    duplicated: true,
    pauseOnHover: true
  });
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.marquee__container'), (el) => {
    window.dAgency.initMarquee(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.marquee__container'), (el) => {
      window.dAgency.initMarquee(el);
    });
  });
}
